import React from 'react';
import { connect } from 'react-redux';
import { CardBody, CardHeader, Alert, Row, Col, Jumbotron, Table, Button } from 'reactstrap';
import { toJS } from '../../containers/to-js';
import { getUserProfile, syncWf } from '../../actions/user';
import Avatar from 'react-avatar';
import config from '../../config';


class Profile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      offlineWF : []
    }
  }
  componentDidMount() {
    this.props.getUserProfile();
    const localStorageKeys = Object.keys(localStorage);
    let offlineWF = [];
    localStorageKeys.map(key => {
      if(key.indexOf('offlinewf') != -1) {
        offlineWF.push(key)
      }
    })
    this.setState({offlineWF})
  }

  syncWf = () => {
    const offlineWF = this.state.offlineWF;
    offlineWF.map(key => {
      const wfVal = localStorage.getItem(key);
      console.log(JSON.parse(wfVal))
      setTimeout(() => { 
        //this.props.syncWf(JSON.parse(wfVal))
        localStorage.removeItem(key)
      },5000)
    })
  }
  render() {
    const { profile } = this.props;
    const { isLoading, hasError, data } = profile;
    if (!data) return null;
    if (isLoading) return <ProfileLoading />;
    if (hasError) return <ProfileError />;
    const { email, firstName, lastName, jobTitle, phoneNumber, role, userAppLogo, profilePicture } = data;
    const user = JSON.parse(localStorage.getItem('user'));
    let appLogo = ""
    if(user && user.userAppLogo) {
      appLogo = `${config.assetsBasePath}${user.userAppLogo}`;
    }
    const fullName = `${firstName} ${lastName}`;
    const offlineWF = this.state.offlineWF;
    const profilePic = `${config.assetsBasePath}${profilePicture}`;

    return <div className='common-container-wrapper profile-main'>
      <Row>
        <Col sm="12" md={{ size: 12 }} lg={{ size: 12 }}>
          <Jumbotron>
            <CardHeader className="text-center" tag="h3">{fullName}</CardHeader>
            <CardBody>
              <div className='profile-avatar'>
                <img 
                  style={{
                    height: 200,
                    width: 200,
                    borderRadius: 100
                  }}
                  src={profilePic}
                />
              </div>
            </CardBody>
            <Table>
              <tbody>
                <tr>
                  <td>First Name</td>
                  <td>:</td>
                  <td>{firstName}</td>
                </tr>
                <tr>
                  <td>Last Name</td>
                  <td>:</td>
                  <td>{lastName}</td>
                </tr>
                <tr>
                  <td>Email</td>
                  <td>:</td>
                  <td>{email}</td>
                </tr>
                <tr>
                  <td>Phone</td>
                  <td>:</td>
                  <td>{phoneNumber}</td>
                </tr>
                <tr>
                  <td>Role</td>
                  <td>:</td>
                  <td>{role}</td>
                </tr>
                {
                  user.userTheme && (
                    <tr>
                      <td>User Theme</td>
                      <td>:</td>
                      <td>{user.userTheme}</td>
                    </tr>
                  )
                }
                {
                  user.userAppLogo && (
                    <tr>
                      <td>Application Logo</td>
                      <td>:</td>
                      <td><div>
                        <img 
                          style={{
                            height: 200,
                            width: 200,
                            borderRadius: 100
                          }}
                          src={appLogo}
                        />
                      </div></td>
                    </tr>
                  )
                }
              </tbody>
            </Table>
            {
              offlineWF.length > 0 && <Button onClick = {this.syncWf.bind(this)}>Sync Offline Workflows</Button>
            }
          </Jumbotron>
        </Col>
      </Row>
    </div>
  }
}

const ProfileLoading = (props) => {
  return <div className='common-container-wrapper'>
      <Alert color='light'>
          <i className="fa fa-spinner fa-pulse fa-1x mr-1 fa-fw"></i>Loading your profile...
      </Alert>
  </div>
}

const ProfileError = (props) => {
  return <div className='common-container-wrapper'>
      <Alert color='danger'>
          <i className="fa fa-exclamation-triangle mr-1"></i>Something went wrong while loading the profile
      </Alert>
  </div>
}

const mapDispatchToProps = (dispatch) => {
  return {
    getUserProfile: () => {
        return dispatch(getUserProfile());
    },
    syncWf: (payload) => {
      return dispatch(syncWf(payload));
    }
  }
};

const mapStateToProps = (state, ownProps) => {
  return {
      profile: state.getIn(['user', 'profile'])
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(toJS(Profile));